<app-full-page-message
  *ngIf="businessId && businessId.length > 5 && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)" />
<div
  *ngIf="!businessId || businessId.length < 5 || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
  <div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.seller && localService.languageContent.common && sellerInitializationWrapper && sellerInitializationWrapper.business">
    <div style="display:none;">
      <i class="material-icons on_language_changed" style="float:left;" (click)="onLoad()">replay_circle_filled</i>
    </div>
    <div class="row" style="text-align:center;" *ngIf="businessId != ''">
      <div class="col-2">
        <i class="material-icons" style="font-size:45px;" (click)="onRoute(1)">add_shopping_cart</i>
        <div class="seller_other_option_text">{{localService.languageContent.seller.add_products}}</div>
      </div>
      <div class="col-2">
        <i class="material-icons" style="font-size:45px;" (click)="onRoute(2)">person_add</i>
        <div class="seller_other_option_text">{{localService.languageContent.seller.add_employees}}</div>
      </div>
      <div class="col-2">
        <i class="material-icons" style="font-size:45px;" (click)="onRoute(3)">watch_later</i>
        <div class="seller_other_option_text">{{localService.languageContent.seller.working_hours}}</div>
      </div>
      <div class="col-2">
        <i class="material-icons" style="font-size:45px;" (click)="onRoute(4)">account_balance_wallet</i>
        <div class="seller_other_option_text">{{localService.languageContent.seller.payment_types}}</div>
      </div>
      <div class="col-2">
        <i class="material-icons" style="font-size:45px;" (click)="onRoute(5)">format_list_numbered</i>
        <div class="seller_other_option_text">{{localService.languageContent.seller.create_billing}}</div>
      </div>
      <div class="col-2">
        <i class="material-icons" style="font-size:45px;" (click)="onRoute(6)">playlist_add_check</i>
        <div class="seller_other_option_text">{{localService.languageContent.seller.my_orders}}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-4 banner_margin">
        <div class="banner">
          <div class="row" style="margin-bottom: 5px;">
            <div class="col-6 dropdown_div">
              <app-label [Text]="localService.languageContent.seller.currency_symbol" [IsMandatory]="true"></app-label>
            </div>
            <div class="col-6 select_dropdown" *ngIf="sellerInitializationWrapper">
              <ngx-select [items]="sellerInitializationWrapper.currencySymbols" [optionValueField]="'key'"
                [optionTextField]="'value'" placeholder="{{localService.languageContent.seller.currency_symbol}}"
                [(ngModel)]="sellerInitializationWrapper.business.content.v16" [noAutoComplete]="false"
                id="{{elementIds.currency_symbol}}">
                <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
                  <span class="en" [innerHTML]="option.data.s_value + '&nbsp;-&nbsp;'"></span>
                  <span>{{option.data.value}}</span>
                </ng-template>
              </ngx-select>
            </div>
          </div>
          <div class="row">
            <div class="dropdown_div col-6">
              <app-label [Text]="localService.languageContent.seller.regional_language"
                [IsMandatory]="true"></app-label>
            </div>
            <div class="select_dropdown col-6" *ngIf="localService.languagesEquivalent">
              <ngx-select [items]="localService.languagesEquivalent" [optionValueField]="'v1'" [optionTextField]="'v3'"
                [(ngModel)]="sellerInitializationWrapper.business.content.v1"
                placeholder="{{localService.languageContent.seller.select}}" [noAutoComplete]="false"
                id="{{elementIds.local_language}}">
              </ngx-select>
            </div>
          </div>
          <div class="row">
            <div class="col-5">
              <app-label [Text]="localService.languageContent.local_locations.postal_code" [IsMandatory]="true">
              </app-label>
            </div>
            <div class="select_dropdown col-7">
              <input id="{{elementIds.postal_code}}" *ngIf="!isAlphaNumericPostalCode" autocomplete="off" type="number"
                class="number" [ngClass]="sellerInitializationWrapper.business.content.v9 ? 'en' : ''"
                [(ngModel)]="sellerInitializationWrapper.business.content.v9" style="text-align:left;"
                (keypress)="localService.isNumberOnly($event,numericConfig)"
                placeholder="*{{localService.languageContent.local_locations.postal_code}}"
                title="*{{localService.languageContent.local_locations.postal_code}}"
                (keydown.enter)="localService.onFocusNextInput(elementIds.name,1)" />
              <input *ngIf="isAlphaNumericPostalCode" autocomplete="off"
                maxlength="{{numericConfig.maxDigits > 0 ? numericConfig.maxDigits : 50}}"
                [ngClass]="sellerInitializationWrapper.business.content.v9 != '' ? 'en' : ''" type="text"
                id="{{elementIds.postal_code}}" [(ngModel)]="sellerInitializationWrapper.business.content.v9"
                placeholder="*{{localService.languageContent.local_locations.postal_code}}"
                title="*{{localService.languageContent.local_locations.postal_code}}"
                (keydown.enter)="localService.onFocusNextInput(elementIds.name,1)" />
            </div>
          </div>
          <app-language-container [MaxLength]="100" [Title]="localService.languageContent.seller.name"
            [(languageContents)]="sellerInitializationWrapper.business.languageContentsName"
            (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,1)" [IsPartiallyMandatory]="true"
            [id]="elementIds.name" [IsNeedNewLine]="true">
          </app-language-container>
          <br />
          <div>
            <div class="row">
              <div class="col-12">
                <app-label [Text]="localService.languageContent.seller.receipt_type" [IsMandatory]="true"></app-label>
                <button class="button_icon button_icon_color icon_adjust" *ngIf="businessId != '' && businessId != '0'"
                  title="{{localService.languageContent.seller.font_settings}}"
                  (click)="onAction(4)">font_download</button>
                &nbsp;
                <button class="button_icon button_icon_color icon_adjust" *ngIf="businessId != '' && businessId != '0'"
                  title="{{localService.languageContent.seller.receipt_icon_config}}"
                  (click)="onAction(5)">image</button>
                &nbsp;
                <button class="button_icon button_icon_color icon_adjust" *ngIf="businessId != '' && businessId != '0'"
                  title="{{localService.languageContent.seller.bill_adjust}}" (click)="onAction(3)">adjust</button>
                &nbsp;
                <button class="button_icon button_icon_color icon_adjust" *ngIf="businessId != '' && businessId != '0'"
                  (click)="onAction(1)" [disabled]="isFixReceiptType"
                  title="{{localService.languageContent.seller.receipt_options}}">settings</button>
                &nbsp;
                <button class="button_icon button_icon_color icon_adjust" *ngIf="businessId != '' && businessId != '0'"
                  title="{{localService.languageContent.seller.clear_cache}}"
                  (click)="onAction(2)">settings_backup_restore</button>
              </div>
            </div>
            <div class="row" *ngIf="sellerInitializationWrapper && (businessId == '' || businessId == '0')">
              <div class="col-12">
                <ngx-select [items]="sellerInitializationWrapper.receiptTypes" [optionValueField]="'key'"
                  [optionTextField]="'value'" placeholder="{{localService.languageContent.seller.select}}"
                  [(ngModel)]="sellerInitializationWrapper.business.content.v2" [noAutoComplete]="false"
                  id="{{elementIds.receipt_type}}" (select)="onCheckReceiptType()">
                </ngx-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 dropdown_div">
              <app-label [Text]="localService.languageContent.seller.my_business_type" [IsMandatory]="true"></app-label>
            </div>
            <div class="col-6 select_dropdown" *ngIf="sellerInitializationWrapper">
              <ngx-select [items]="sellerInitializationWrapper.businessTypes" [optionValueField]="'key'"
                [optionTextField]="'value'" placeholder="{{localService.languageContent.seller.select_business_type}}"
                [(ngModel)]="sellerInitializationWrapper.business.content.v8" [noAutoComplete]="true"
                id="{{elementIds.business_type}}">
              </ngx-select>
            </div>
          </div>
          <div>
            <div class="dropdown_div">
              <app-label [Text]="localService.languageContent.seller.expect_business_type"
                [IsPartiallyMandatory]="true">
              </app-label>
            </div>
            <div class="select_dropdown" *ngIf="sellerInitializationWrapper">
              <ngx-select [items]="sellerInitializationWrapper.businessTypes" [optionValueField]="'key'"
                [optionTextField]="'value'" [multiple]="true" [noAutoComplete]="true"
                placeholder="{{localService.languageContent.seller.select_business_type}}"
                [(ngModel)]="sellerInitializationWrapper.business.expectedBusinessTypes"
                id="{{elementIds.expected_business}}">
              </ngx-select>
            </div>
          </div>
          <div>
            <div class="dropdown_div">
              <app-label [Text]="localService.languageContent.seller.delivery_type" [IsPartiallyMandatory]="true">
              </app-label>
            </div>
            <div class="select_dropdown" *ngIf="sellerInitializationWrapper">
              <ngx-select [items]="sellerInitializationWrapper.deliveryTypes" [optionValueField]="'key'"
                [optionTextField]="'value'" [multiple]="true" [noAutoComplete]="true"
                placeholder="{{localService.languageContent.seller.select_delivery_type}}"
                [(ngModel)]="sellerInitializationWrapper.business.deliveryTypes" id="{{elementIds.delivery_type}}">
              </ngx-select>
            </div>
          </div>
          <div class="row styled_row">
            <div class="col-3">
              <app-label [Text]="localService.languageContent.common.upi"></app-label>
            </div>
            <div class="col-9">
              <input autocomplete="off" [ngClass]="sellerInitializationWrapper.business.content.v11 != '' ? 'en' : ''"
                type="text" [(ngModel)]="sellerInitializationWrapper.business.content.v11"
                placeholder="{{localService.languageContent.common.upi}}"
                title="{{localService.languageContent.common.upi}}" />
            </div>
          </div>
          <div>
            <app-mapping-container [items]="sellerInitializationWrapper.business.contactNumbers"
              (onValuesUpdated)="onValuesUpdated($event,1)" [isOnlyNumbers]="true" [isStartWithZero]="true"
              [Title]="localService.languageContent.seller.map_contact_num"></app-mapping-container>
          </div>
          <div>
            <app-mapping-container [items]="sellerInitializationWrapper.business.emails"
              (onValuesUpdated)="onValuesUpdated($event,2)" [Title]="localService.languageContent.seller.map_email">
            </app-mapping-container>
          </div>
          <div class="box">
            <div>
              <app-label [Text]="localService.languageContent.seller.product_labels"></app-label>
            </div>
            <div *ngFor="let item of sellerInitializationWrapper.business.productLabels">
              <label style="margin-left:20px;font-weight:normal;">
                <input type="checkbox" [(ngModel)]="item.isSelected">
                <span class="en">{{item.key}}.</span>
              </label>
              <input autocomplete="off" type="text" [(ngModel)]="item.value" style="width: calc(100% - 50px);"
                placeholder="{{localService.languageContent.seller.product_label}}"
                title="{{localService.languageContent.seller.product_label}}" />
            </div>
          </div>
          <div class="box" *ngIf="businessId.length > 0">
            <button class="btn btn-primary" [disabled]="sellerInitializationWrapper.business.content.v23 == '0'"
              (click)="onResetAcceptanceNumber()">
              {{localService.languageContent.seller.reset_acceptance_number}}
              <span>&nbsp;-&nbsp;{{sellerInitializationWrapper.business.content.v23}}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm-4 banner_margin">
        <div class="banner">
          <app-supporting-lines *ngIf="!isSellerLoading"
            [businessTaxCategories]="sellerInitializationWrapper.business.taxCategories"
            [(businessTaxes)]="sellerInitializationWrapper.taxes" [IsNumber]="true" [isNegativeAllowed]="false"
            [maxValue]="100" [countryCode]="ctryCode" [businessId]="businessId"></app-supporting-lines>
          <app-supporting-lines [(items)]="sellerInitializationWrapper.supporting"></app-supporting-lines>

          <div>
            <app-label [Text]="localService.languageContent.seller.service_charge" />
            <input id="{{elementIds.service_charge}}" autocomplete="off" type="number" class="number"
              [ngClass]="sellerInitializationWrapper.business.content.v25 ? 'en' : ''"
              [(ngModel)]="sellerInitializationWrapper.business.content.v25" style="text-align:left;width: 100px;"
              placeholder="{{localService.languageContent.seller.service_charge}}"
              title="*{{localService.languageContent.seller.service_charge}}" />
          </div>

          <app-language-container [MaxLength]="300" [Title]="localService.languageContent.seller.address"
            [IsLargeText]="true" [(languageContents)]="sellerInitializationWrapper.business.languageContentsAddress"
            (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,2)" [IsPartiallyMandatory]="true"
            [id]="elementIds.address"></app-language-container>
          <br />
          <app-language-container [MaxLength]="3000" [Title]="localService.languageContent.seller.description"
            [IsLargeText]="true" [(languageContents)]="sellerInitializationWrapper.business.languageContentsDescription"
            (onEmptyLanguageContainerAdded)="onEmptyLanguageContainerAdded($event,3)"></app-language-container>
        </div>
        <div class="banner" style="margin-top: 10px;">
          <div>
            <span>
              {{localService.languageContent.seller.token_info}}
            </span>
          </div>
          <div class="box">
            <div>
              <app-label [Text]="localService.languageContent.seller.token_prefix" />
              <input id="{{elementIds.token_prefix}}" autocomplete="off" type="text"
                [ngClass]="sellerInitializationWrapper.business.content.v20 ? 'en' : ''"
                [(ngModel)]="sellerInitializationWrapper.business.content.v20" style="text-align:left;width: 100px;"
                (input)="onFormatSampleBill()" placeholder="{{localService.languageContent.seller.token_prefix}}"
                title="*{{localService.languageContent.seller.token_prefix}}" />
            </div>
            <div>
              <app-label [Text]="localService.languageContent.seller.token_split_char" />
              <input id="{{elementIds.token_split_char}}" autocomplete="off" type="text"
                [ngClass]="sellerInitializationWrapper.business.content.v19 ? 'en' : ''"
                [(ngModel)]="sellerInitializationWrapper.business.content.v19" style="text-align:left;width: 100px;"
                (input)="onFormatSampleBill()" placeholder="{{localService.languageContent.seller.token_split_char}}"
                title="*{{localService.languageContent.seller.token_split_char}}" />
            </div>
            <div>
              <app-label [Text]="localService.languageContent.seller.token_min_digits" />
              <input id="{{elementIds.token_min_digits}}" autocomplete="off" type="number" class="number"
                [ngClass]="sellerInitializationWrapper.business.content.v21 ? 'en' : ''"
                [(ngModel)]="sellerInitializationWrapper.business.content.v21" (input)="onFormatSampleBill()"
                style="text-align:left;width: 100px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
                placeholder="{{localService.languageContent.seller.token_min_digits}}"
                title="*{{localService.languageContent.seller.token_min_digits}}" />
            </div>
            <div>
              <div class="row">
                <div class="col-6">
                  <app-label [Text]="localService.languageContent.seller.token_prefix_format" />
                </div>
                <div class="col-6">
                  <ngx-select [items]="tokenFormatTypes" [optionValueField]="'key'" [optionTextField]="'value'"
                    [(ngModel)]="sellerInitializationWrapper.business.content.v22" (select)="onFormatSampleBill()"
                    placeholder="{{localService.languageContent.seller.select}}" [noAutoComplete]="true">
                  </ngx-select>
                </div>
              </div>
            </div>
            <div>
              <app-label [Text]="localService.languageContent.seller.token_date_split_char" />
              <input id="{{elementIds.token_date_split_char}}" autocomplete="off" type="text"
                [ngClass]="sellerInitializationWrapper.business.content.v24 ? 'en' : ''"
                [(ngModel)]="sellerInitializationWrapper.business.content.v24" style="text-align:left;width: 100px;"
                (input)="onFormatSampleBill()"
                placeholder="{{localService.languageContent.seller.token_date_split_char}}"
                title="*{{localService.languageContent.seller.token_date_split_char}}" />
            </div>
            <div>
              <app-label [Text]=" localService.languageContent.seller.token_start_nbr" />
              <input id="{{elementIds.token_start_nbr}}" autocomplete="off" type="number" class="number"
                [ngClass]="sellerInitializationWrapper.business.content.v18 ? 'en' : ''"
                [(ngModel)]="sellerInitializationWrapper.business.content.v18" (input)="onFormatSampleBill()"
                style="text-align:left;width: 100px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
                placeholder="{{localService.languageContent.seller.token_start_nbr}}"
                title="*{{localService.languageContent.seller.token_start_nbr}}" />
            </div>
          </div>
          <div>
            <span>{{localService.languageContent.seller.sample_format_fin_year}}</span>
            <br />
            <span class="en">&nbsp;({{financeYearRange}})</span>
            <span class="en" style="font-weight: bold;">&nbsp;:&nbsp;{{sampleBillFormat}}</span>
          </div>
          <div>
            <span>{{localService.languageContent.seller.sample_format}}</span>
            <span class="en" style="font-weight: bold;">&nbsp;:&nbsp;{{sampleTokenFormat}}</span>
          </div>
          <div *ngIf="businessId && businessId.length > 5" style="text-align: center;">
            <button class="btn btn-primary" [disabled]="sampleBillFormat != sampleTokenFormatInDb"
              (click)="onReformatInvoiceNumber()">
              {{ localService.languageContent.seller.reformat_bill}}
              <div class="en">({{financeYearRange}})</div>
            </button>
          </div>
        </div>
        <div class="banner" style="margin-top: 10px;" *ngIf="businessId && businessId.length > 5">
          <div>
            <span>Business Code:</span>
          </div>
          <div class="otp">
            {{sellerInitializationWrapper.business.content.v26}}
          </div>
          <div>
            <span>Business PIN:</span>
          </div>
          <div *ngIf="verificationPin" class="otp">
            {{verificationPin}}
          </div>
          <div style="text-align: center;">
            <button class="btn btn-primary" (click)="onGeneratePin()">
              Generate PIN
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm-4 banner_margin">
        <div class="banner">
          <div *ngIf="sellerInitializationWrapper?.business?.businessEnabledOptions">
            <div class="styled_row" *ngFor="let item of sellerInitializationWrapper.business.businessEnabledOptions">
              <label style="margin-left:20px;font-weight:normal;" *ngIf="!item.isInVisible">
                <input type="checkbox" [(ngModel)]="item.isSelected" (click)="onSelectOption(item.key)">
                <span style="color:darkslategrey">{{item.text}}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dummy">
      &nbsp;
    </div>
    <div class="dummy">
      &nbsp;
    </div>
    <div class="dummy">
      &nbsp;
    </div>
  </div>
  <div class="{{localService.selectedLanguageCode}} footer"
    *ngIf="sellerInitializationWrapper && sellerInitializationWrapper.business">
    <i class="material-icons" style="float: left; font-size: 2em; margin: 5px;" (click)="onRoute(8)"
      *ngIf="businessId != ''">add_circle_outline</i>
    <span class="label_b" style="margin-right:15px;"
      *ngIf="businessId == ''">{{localService.languageContent.seller.new_business}}</span>
    <span class="label_b" style="margin-right:15px;" *ngIf="businessId != '' && businessName && businessName.key != ''"
      [ngClass]="localService.getLanguageCode(businessName.key)">{{businessName.value}}</span>
    &nbsp;
    <button class="btn btn-primary" (click)="onSave()">{{businessId != '' ? localService.languageContent.common.save
      :
      localService.languageContent.common.create}}</button>
  </div>
</div>
<div *ngIf="businessId && businessId.length > 5 && sellerInitializationWrapper && sellerInitializationWrapper.business">
  <span style="display: none;">
    <button id="btnCloseUserAuthenticationFromSeller" (click)="onCloseUserAuthentication(true)">OnCloseUserAuth</button>
  </span>
  <app-user-authentication [(isOpenPopup)]="isOpenUserAuthentication" [BusinessId]="businessId" [relationshipRole]="2"
    [relationShipType]="2" (onClose)="onCloseUserAuthentication(false,$event)"
    [btnIdToTriggerWhileClose]="'btnCloseUserAuthenticationFromSeller'"
    [IsCloseAfterCreation]="false"></app-user-authentication>
  <app-receipt-options *ngIf="businessId != '' && businessId != '0'" [(isOpenPopup)]="isOpenReceiptOptions"
    [businessId]="businessId" (onClose)="onCloseReceiptOptions($event)"
    [receiptType]="sellerInitializationWrapper.business.content.v2"></app-receipt-options>
  <app-product-details [(isOpenPopup)]="isProductDetailPopupOpen" [businessId]="businessId"
    [isNotConsiderTax]="isNotConsiderTax" [businessTaxes]="businessTaxes" [isInventoryEnabled]="isInventoryEnabled"
    (onClose)="onClosesProductDetailPopup($event)"
    [businessTaxCategories]="sellerInitializationWrapper.business.taxCategories"></app-product-details>
  <app-working-hours-popup [(isOpenPopup)]="isWorkingHoursPopupOpen" [isOnlyTime]="true"
    [selectedRange]="selectedRangeWorkingHours" (onClose)="onClosesWorkingHoursPopup($event)"></app-working-hours-popup>
  <app-billing-adjust-formula *ngIf="businessId && businessId!='0'" [(isOpen)]="isOpenBillingAdjustmentFormula"
    [businessId]="businessId" [countryCode]="ctryCode" (onClose)="isOpenBillingAdjustmentFormula = false" />
</div>
<div *ngIf="businessId && businessId.length > 5">
  <app-font-settings-config [(isOpenPopup)]="isOpenFontSettings" [businessId]="businessId" />
  <app-receipt-icon-config [(isOpenPopup)]="isReceiptIconConfig" [businessId]="businessId" />
  <app-message-box *ngIf="isOpenConfirmationBox" [IsConfirmationType]="true" (onClose)="onConfirmed($event)"
    [IsPopup]="true"
    [message]="confirmationType == 2?  localService.languageContent.seller.confirm_reset_acceptance_number:  localService.languageContent.seller.confirm_reformat" />
  <span style="display: none;">
    <button class="after_access_check" (click)="onAfterAccessCheck()">After Access Check</button>
  </span>
</div>